/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import KTOffcanvas from "../../../_metronic/_assets/js/offcanvas";
import { Badge } from "@mui/material";
import { FormattedMessage } from "react-intl";
import MenuItemsHelper from "../../store/helpers/MenuItemsHelper";
import SystemHelper from "../../shared/systemHelper";


export default class StickyToolbar extends React.Component {
  constructor(props) {
    super(props);

  }
  componentDidMount() {
    const panel2 = document.getElementById("kt_quick_panel_2");
    this.offCanvas2 = new KTOffcanvas(panel2, {
      overlay: true,
      baseClass: "kt-quick-panel",
      closeBy: "kt_quick_panel_close_btn_2",
      toggleBy: "kt_quick_panel_toggler_btn_2",
    });
    this.offCanvas2.on('afterHide', () => { this.updatePanelStatus(2, false); })
    this.offCanvas2.on('afterShow', () => { this.updatePanelStatus(2, true); })


    const panel3 = document.getElementById("kt_quick_panel_3");
    this.offCanvas3 = new KTOffcanvas(panel3, {
      overlay: true,
      baseClass: "kt-quick-panel",
      closeBy: "kt_quick_panel_close_btn_3",
      toggleBy: "kt_quick_panel_toggler_btn_3",
    });
    this.offCanvas3.on('afterHide', () => { this.updatePanelStatus(3, false); })
    this.offCanvas3.on('afterShow', () => { this.updatePanelStatus(3, true); })
  }

  updatePanelStatus = (panelNum, isOpen) => {
    this.props.onToggle(panelNum, isOpen);
    if (panelNum === 2 && isOpen) {
      SystemHelper.hubspotUpdateEvent("CONTRACT_OPEN_ACTIONS_PANEL");
    }
    if (panelNum === 3 && isOpen) {
      SystemHelper.hubspotUpdateEvent("CONTRACT_OPEN_PENDING_DRAFTS_PANEL");
    }
  }

  render() {
    return (
      <>
        <ul className="kt-sticky-toolbar" >


          <OverlayTrigger
            placement="left"
            overlay={<Tooltip id="layout-tooltip"><FormattedMessage id="GENERAL.WORDS.ACTIONS" /></Tooltip>}
          >
            <Badge
              anchorOrigin={{ horizontal: "left", vertical: 'top' }}
              invisible={!(this.props.actionCount)}
              badgeContent={this.props.actionCount}
              color={MenuItemsHelper.getBadgeColorForRAGColor(this.props.actionRAGColor, "mui")}
              overlap="rectangular"
            >
              <li
                className="kt-sticky-toolbar__item kt-sticky-toolbar__item--brand"
                data-placement="left"
              // style={{ marginBottom: '5px' }}
              >
                <span
                  ref={this.props.panelCloseBtnRef2}
                  className="kt-header__topbar-icon"
                  id="kt_quick_panel_toggler_btn_2"
                >
                  <i className="flaticon2-check-mark" />
                </span>
              </li>
            </Badge>
          </OverlayTrigger>

          <OverlayTrigger
            placement="left"
            overlay={<Tooltip id="layout-tooltip"><FormattedMessage id="DASHBOARD.PENDING_DRAFTS" /></Tooltip>}
          >
            <Badge
              anchorOrigin={{ horizontal: "left", vertical: 'top' }}
              invisible={!(this.props.pendingDraftCount)}
              badgeContent={this.props.pendingDraftCount}
              color="secondary"
              overlap="rectangular"
            >
              <li
                className="kt-sticky-toolbar__item kt-sticky-toolbar__item--brand"
                data-placement="left"
              >
                <span
                  ref={this.props.panelCloseBtnRef3}
                  className="kt-header__topbar-icon"
                  id="kt_quick_panel_toggler_btn_3"
                >
                  <i className="flaticon2-pen" />
                </span>
              </li>
            </Badge>
          </OverlayTrigger>

        </ul>
      </>
    );
  };
}
